import { useState } from 'react'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { MusicPlayer } from './components/MusicPlayer'
import { PlaylistView } from './components/PlaylistView'
import { Services } from './components/Services'
import { Gallery } from './components/Gallery'
import { Testimonials } from './components/Testimonials'
import { BookingForm } from './components/BookingForm'
import { Track } from './types/audio'
import { sampleTracks } from './data/sampleTracks'
import './App.css'

function App() {
  const [currentTrack, setCurrentTrack] = useState<Track | null>(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [showBookingForm, setShowBookingForm] = useState(false)
  const [selectedService, setSelectedService] = useState<string>('')

  const handleTrackSelect = (track: Track) => {
    setCurrentTrack(track)
    setIsPlaying(true)
  }

  const handleNextTrack = () => {
    if (!currentTrack) return
    const currentIndex = sampleTracks.findIndex(track => track.id === currentTrack.id)
    const nextIndex = (currentIndex + 1) % sampleTracks.length
    setCurrentTrack(sampleTracks[nextIndex])
  }

  const handlePrevTrack = () => {
    if (!currentTrack) return
    const currentIndex = sampleTracks.findIndex(track => track.id === currentTrack.id)
    const prevIndex = (currentIndex - 1 + sampleTracks.length) % sampleTracks.length
    setCurrentTrack(sampleTracks[prevIndex])
  }

  const handleBookingClick = (serviceId: string) => {
    setSelectedService(serviceId)
    setShowBookingForm(true)
  }

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Services onBookService={handleBookingClick} />
        <Gallery />
        <Testimonials />
        <div className="music-section">
          <h2>Sample Our Music</h2>
          <PlaylistView 
            onTrackSelect={handleTrackSelect}
            currentTrack={currentTrack}
          />
        </div>
      </main>
      <MusicPlayer 
        currentTrack={currentTrack}
        isPlaying={isPlaying}
        onPlayPause={() => setIsPlaying(!isPlaying)}
        onNextTrack={handleNextTrack}
        onPrevTrack={handlePrevTrack}
      />
      {showBookingForm && (
        <BookingForm 
          serviceId={selectedService}
          onClose={() => setShowBookingForm(false)}
        />
      )}
      <Footer />
    </div>
  )
}

export default App
